import React from 'react';
import {
  FormControlLabel,
  Checkbox,
  Stack,
  SxProps,
  Theme,
} from '@mui/material';
import { TextInput } from 'src/UIKit/components';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { UseExpirationDateResult } from 'src/modules/shortLinks/hooks';

interface ExpirationDateFormProps {
  expirationState: UseExpirationDateResult;
  disabled?: boolean;
  showHelperText?: boolean;
  sx?: SxProps<Theme>;
}

export const ExpirationDateForm: React.FC<ExpirationDateFormProps> = ({
  expirationState,
  disabled = false,
  showHelperText = true,
  sx = {},
}) => {
  const {
    hasExpiration,
    expirationDate,
    expirationError,
    setHasExpiration,
    setExpirationDate,
  } = expirationState;

  return (
    <Stack gap={2} sx={sx}>
      <FormControlLabel
        control={
          <Checkbox
            checked={hasExpiration}
            onChange={(e) => setHasExpiration(e.target.checked)}
            disabled={disabled}
          />
        }
        label="Set expiration date"
      />

      {hasExpiration && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            label="Expiration Date"
            value={expirationDate}
            onChange={(newValue) => setExpirationDate(newValue)}
            minDateTime={dayjs()}
            ampm
            format="MM/DD/YYYY hh:mm A"
            disabled={disabled}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: true,
                error: !!expirationError,
                helperText: showHelperText ? (expirationError || 'Select when this link should expire') : expirationError || ' ',
              },
            }}
          />
        </LocalizationProvider>
      )}

      {!hasExpiration && (
        <TextInput
          label="Expiration Date"
          value="Link will never expire"
          disabled
          margin="none"
          onChange={() => undefined}
          helperText={showHelperText ? ' ' : undefined}
        />
      )}
    </Stack>
  );
};
